import React, { useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Editor from '@monaco-editor/react';
import { useMutation } from 'react-fetching-library';
import { Modal, Card, CardContent, Stack, Button, Portal, Typography, TextField, Alert, Checkbox } from '@mui/material';

import { createJsonFormAction } from '../../services/request';

const validationSchema = Yup.object({
  identifier: Yup.string().required('To pole nie może być puste'),
  version: Yup.number().required('To pole nie może być puste'),
  description: Yup.string()
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const jsonSchemaDefault = JSON.stringify({
  'type': 'object',
  'required': [],
  'properties': {}
});

const jsonSchemaUIDefault = JSON.stringify({
  'type': 'VerticalLayout',
  'elements': []
});

export default function JsonFormUpdateCreate ({ open, setOpen, setForms, form = null }) {
  const { loading, mutate, error, reset } = useMutation(createJsonFormAction);
  const [jsonSchema, setJsonSchema] = useState(_.isNil(form) ? jsonSchemaDefault : JSON.stringify(form.json_schema));
  const [jsonSchemaUI, setJsonSchemaUI] = useState(_.isNil(form) ? jsonSchemaUIDefault : JSON.stringify(form.json_schema_ui));

  const handleJsonSchemaChange = (value, event) => {
    setJsonSchema(value);
  };

  const handleJsonSchemaUIChange = (value, event) => {
    setJsonSchemaUI(value);
  };

  const handleOnMount = (editor, monaco) => {
    setTimeout(() => editor.getAction('editor.action.formatDocument').run(), 300);
  };

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, _.isNil(form) ? 'POST' : 'PATCH', _.isNil(form) ? null : form.id);

    if (!error) {
      if (_.isNil(form)) {
        setForms(prev => [payload, ...prev]);
      } else {
        setForms(prev => prev.map(item => item.id === payload.id ? payload : item));
      }
      reset();
      formik.resetForm();
      setJsonSchema(jsonSchemaDefault);
      setJsonSchemaUI(jsonSchemaUIDefault);
      setOpen(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      identifier: _.isNil(form) ? '' : form.identifier,
      version: _.isNil(form) ? '' : form.version,
      description: _.isNil(form) ? '' : form.description,
      recaptcha: _.isNil(form) ? false : form.recaptcha
    },
    validateOnChange: false,
    validationSchema,
    onSubmit: values => {
      values.json_schema = JSON.parse(jsonSchema);
      values.json_schema_ui = JSON.parse(jsonSchemaUI);
      handleSubmit(values);
    }
  });

  return (

    <Portal >
      <Modal open={open} onClose={() => setOpen(false)}>
        <Card sx={{ ...style, width: '85vw' }}>
          <CardContent>
            <form onSubmit={formik.handleSubmit}>
              <Stack direction="row" sx={{ mb: 2 }} spacing={5}>
                <TextField
                  id="identifier"
                  size="small"
                  label="Identyfikator"
                  fullWidth
                  value={formik.values.identifier}
                  onChange={formik.handleChange}
                  error={formik.errors.identifier && formik.touched.identifier}
                  helperText={formik.errors.identifier}
                />
                <TextField
                  id="version"
                  size="small"
                  label="Wersja"
                  type="number"
                  fullWidth
                  value={formik.values.version}
                  onChange={formik.handleChange}
                  error={formik.errors.version && formik.touched.version}
                  helperText={formik.errors.version}
                />
              </Stack>
              <Stack>
                <TextField id="description" size="small" label="opis" multiline maxRows={3} sx={{ mb: 2 }} value={formik.values.description} onChange={formik.handleChange}/>
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%" sx={{ mb: 2 }}>
                <Typography variant="subtitle2">Recaptcha</Typography>
                <Checkbox id="recaptcha" checked={formik.values.recaptcha} onChange={formik.handleChange}/>
              </Stack>
              <Stack direction="row" spacing={5}>
                <Stack sx={{ flex: '1 1 50%' }}>
                  <Typography variant="subtitle1">Json Schema:</Typography>
                  <Editor
                    height="500px"
                    language="json"
                    theme="vs-dark"
                    value={jsonSchema}
                    onMount={handleOnMount}
                    onChange={handleJsonSchemaChange}
                  />
                </Stack>
                <Stack sx={{ flex: '1 1 50%' }}>
                  <Typography variant="subtitle1">UI Schema:</Typography>
                  <Editor
                    height="500px"
                    language="json"
                    theme="vs-dark"
                    value={jsonSchemaUI}
                    onMount={handleOnMount}
                    onChange={handleJsonSchemaUIChange}
                  />
                </Stack>
              </Stack>
              { error
                ? <Alert variant="outlined" severity="error" sx={{ mt: 4 }}>Wystąpił błąd. Upewnij się czy identyfikator z taką wersją nie jest już utworzony.</Alert>
                : null}
              <Stack direction="row" sx={{ mt: 4 }} spacing={5}>
                <Button variant="outlined" sx={{ width: '100%' }} onClick={() => setOpen(false)}>Anuluj</Button>
                <Button
                  disabled={jsonSchema.trim() === '' || jsonSchemaUI.trim() === ''}
                  variant="contained"
                  sx={{ width: '100%' }}
                  type="submit">
                  {_.isNil(form) ? 'Dodaj' : 'Edytuj'}
                </Button>
              </Stack>
            </form>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
